import { getXVerdictSlaTargets } from '@/services/xverdict_sla_service';

function parse_error_response(error = {}) {
  const data = error?.response?.data;
  if (typeof data !== 'string') return data || {};

  try {
    return JSON.parse(data);
  } catch {
    return {};
  }
}

function targets_error_message(error) {
  const response_data = parse_error_response(error);
  return response_data?.message || error?.message || 'Failed to load SLA configurations.';
}

function start_targets_loading(component) {
  component.loading_targets = true;
  component.targets_error = '';
}

function apply_targets(component, targets = []) {
  component.targets = targets;
}

function apply_targets_error(component, error) {
  component.targets = [];
  component.targets_error = targets_error_message(error);
}

function finish_targets_loading(component) {
  component.loading_targets = false;
}

async function load_targets_for_component(component) {
  start_targets_loading(component);
  try {
    apply_targets(component, await getXVerdictSlaTargets({
      project_id: component.projectId,
      is_active: true,
    }));
  } catch (error) {
    apply_targets_error(component, error);
  } finally {
    finish_targets_loading(component);
  }
}

export default {
  name: 'SlaWorkflows',
  props: {
    projectId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    targets: [],
    loading_targets: false,
    targets_error: '',
  }),
  computed: {
    targets_count() {
      return this.targets.length;
    },
  },
  mounted() {
    this.load_targets();
  },
  methods: {
    async load_targets() {
      return load_targets_for_component(this);
    },
  },
};
